<template>
  <div style="margin: 0 auto;width:700px;">
    <el-card class="box-card" style="margin-top:50px" v-if="show">
      <avue-form :option="option" v-model="form" @submit="submit">
        <template slot-scope="{ size }" slot="menuForm">
          <el-button icon="el-icon-back" :size="size" @click="goback"
            >返回</el-button
          >
        </template>
      </avue-form>
    </el-card>
  </div>
</template>

<script>
import idaas from "@/apis/idaas";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      var f = this.checkPass(value);
      if (f.judge) {
        callback(new Error(f.errTest));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      show: false,
      option: {
        submitText: "确认",
        emptyBtn: false,
        column: [
          {
            label: "原密码",
            prop: "password",
            type: "password",
            span: 24,
          },
          {
            label: "新密码",
            prop: "newPassword",
            type: "password",
            span: 24,
            rules: [{ validator: validatePass, trigger: "blur" }],
          },
          {
            label: "确认新密码",
            prop: "newPassword2",
            type: "password",
            span: 24,
            rules: [{ validator: validatePass2, trigger: "blur" }],
          },
        ],
      },
      form: {},
    };
  },
  async created() {
    document.title = "修改用名密码";
    await idaas.me()
    this.show=true
  },
  methods: {
    async submit(form, done) {
      idaas
        .changePassword(form)
        .then(() => {
          done();
          this.goback();
        })
        .catch(() => {
          done();
        });
    },
    goback() {
      history.go(-1);
    },
    checkPass(login_passwd_new) {
      let errTest = "";
      if (login_passwd_new.length < 8) {
        errTest += "【长度要在8位以上】";
      }
      if (!/([A-Za-z]+)/.test(login_passwd_new)) {
        errTest += "【必须包含字母】";
      }
      if (!/([0-9]+)/.test(login_passwd_new)) {
        errTest += "【必须包含数字】";
      }
      if (!/[^A-Za-z0-9\u4e00-\u9fa5]/.test(login_passwd_new)) {
        errTest += "【必须包含特殊字符】";
      }
      if (/[\u4e00-\u9fa5]/.test(login_passwd_new)) {
        errTest += "【不能输入汉字】";
      }
      if (login_passwd_new.indexOf(" ") >= 0) {
        errTest += "【不能输入空格】";
      }
      if (!this.LxStr(login_passwd_new)) {
        errTest += "【不能连续字符（如123、abc）连续3位或3位以上】";
      }
      if (errTest.length > 0) {
        return {
          judge: true,
          errTest: "密码" + errTest,
        };
      } else {
        return {
          judge: false,
        };
      }
    },
    LxStr(str) {
      var arr = str.split("");
      var flag = true;
      for (var i = 1; i < arr.length - 1; i++) {
        var firstIndex = arr[i - 1].charCodeAt();
        var secondIndex = arr[i].charCodeAt();
        var thirdIndex = arr[i + 1].charCodeAt();
        if (thirdIndex - secondIndex == 1 && secondIndex - firstIndex == 1) {
          flag = false;
        }
      }
      return flag;
    },
  },
};
</script>

<style></style>
